import { Component, Input, NgModule, OnInit, ViewChild } from '@angular/core';
import { FormsModule, NgForm } from '@angular/forms';
import { Router, RouterModule } from '@angular/router';
import {AuthService, Logger} from '@patientlynk3/services';
import { CommonModule } from '@angular/common';
import { ShowPasswordModule } from '@patientlynk3/directives/show-password.directive';
import { TranslocoModule } from '@ngneat/transloco';
import { LazyNgxMaskModule } from '@patientlynk3/utils/forLazyRoot';
import { ButtonLoadingDirectiveModule } from '@patientlynk3/directives/button-loading.directive';
import { BiometricsService } from '@patientlynk3/services/biometrics/biometrics.service';
import { App } from '@capacitor/app'
import { Capacitor } from '@capacitor/core';
import { Dialog } from '@capacitor/dialog';
import { theme } from '@theme/.';
import { PushNotificationsService } from "@patientlynk3/services/push_notifications/push-notifications.service"

@Component({
  selector: 'app-login-form',
  templateUrl: './login-form.component.html',
  styleUrls: ['./login-form.component.scss']
})
export class LoginFormComponent implements OnInit {
  @Input() username = '';
  @ViewChild('user') userForm;

  isNative = Capacitor.isNativePlatform()
  mfaCode: string;
  mfaRequired:boolean = false;
  failedAttempts:number = 0;
  loading:boolean = false;
  bioAvail:boolean = false;
  showBioScreen:boolean = false;
  authBioEnabled:boolean = false; //global check to see if returning user has enabled biometrics
  userRefusedBiometric:boolean = false; //secondary check to check if 'biometric' sring exists meaning users manually dissabled in privacy settings
  serverString:string = '';
  bioInfoExists:boolean = false;
  bioUser:string = '';
  bioPassw:string = '';
  themeImage = `@patientlynk3/../assets/${theme.name.toLowerCase()}/img/PNG/icon.png`;
  navigation_event = ''

  constructor(private bioService: BiometricsService, private logger: Logger, private auth: AuthService, private router: Router, private pushNotifications: PushNotificationsService) {
    if (this.router.getCurrentNavigation().extras.state) {      
      this.navigation_event = this.router.getCurrentNavigation().extras.state["returnUrl"]
    }

    if (this.isNative) {
      App.getInfo().then((data) => {
        this.serverString = data.id
        this.bioService.pullCredentials(data.id).then((data) => {
          console.log("bioService.pullCredentials", data);
          if (data.username != 'biometric') {
            this.authBioEnabled = true;
            this.showBioScreen = true;
          } else {
            this.authBioEnabled = false
            this.showBioScreen = false;
            this.userRefusedBiometric = true;
          }
        }, (error) =>{
          this.authBioEnabled = false
          this.showBioScreen = false;
        })
      })
      this.bioService.biometricAvailable().then(data => this.bioAvail = data)
    }
  }

  ngOnInit() {

    if (this.isNative) {
      setTimeout(() => {
        if (this.authBioEnabled == true) {
          this.authBioEnabled = true;
          this.showBioScreen = true;
          this.invokeBiometrics()   
        }
      }, 1000);
    }
  }

  async handleNavigation(userData){
      //Do you want to enable biometric (first time)
      //yes? do the bio thing
      //no? continue as normal
      
      if (this.bioAvail == true) {

        let acceptStatus:any = false;

        if((this.authBioEnabled == false && this.userRefusedBiometric == false) && this.isNative){
          const { value } = await Dialog.confirm({
            title: 'Enable biometrics?',
            message: "For easier login",
            okButtonTitle:"Enable", 
            cancelButtonTitle:"Cancel"
          });
                
          acceptStatus = value;
        }
  
        if((this.authBioEnabled == false && this.userRefusedBiometric == false) && acceptStatus == true){
          let verifyIdentity = await this.bioService.verifyIdentity()        
  
          console.log("verifyIdentity", verifyIdentity)

          if (verifyIdentity) {
            let setCredential = await this.bioService.setCredential(userData)
            console.log("setCredential", setCredential);
            if (setCredential) {
              await this.bioService.enableBiometrics("1");
            }
            this.pushNotifications.initPush(userData.user_id);
            this.router.navigate([this.navigation_event || '/home']);
          } else {
            this.bioService.setCredential({username: 'biometric', password:'', server: this.serverString})
            this.authBioEnabled = false;
            this.showBioScreen = false;
            this.pushNotifications.initPush(userData.user_id);
            this.router.navigate([this.navigation_event || '/home']);
          }
        } else {
          this.pushNotifications.initPush(userData.user_id);
          this.router.navigate([this.navigation_event || '/home']);
        }

        if (!acceptStatus && this.authBioEnabled == false) {          
          this.bioService.setCredential({username: 'biometric', password:'', server: this.serverString})
          this.authBioEnabled = false;
          this.showBioScreen = false;
          this.pushNotifications.initPush(userData.user_id);
          this.router.navigate([this.navigation_event || '/home']);
        }
      } else {
        this.pushNotifications.initPush(userData.user_id);
        this.router.navigate([this.navigation_event || '/home']);
      }

  }

  /*----------------------------------------------------------*/
  // login user normally with email/password
  submit(user: NgForm) {

    this.loading = true;
    this.logger.clearBanner();
    Object.values(user.controls).forEach(item => item.markAsDirty());
    var { username, password } = user.value;

    if (!username || !password) {
      this.logger.showBanner({ translate: 'loginBlankFields', type: 'error' });
      this.loading = false;
      return;
    }

    if (user.controls.username.invalid) { // TODO: translate
      this.logger.showBanner({ translate: 'enterValidEmail', type: 'error' });
      this.loading = false;
      return;
    }

    this.auth.login({username, password, mfa_code: this.mfaCode}).subscribe(async mfaRequired => {
      this.loading = false;
      if (mfaRequired) {
        this.mfaRequired = true;
        this.showBioScreen = false;
        this.logger.showBanner({
          translate: 'mfaRequired',
          type: 'info',
        });
      } else {
        console.log("this.auth.getPayload()", this.auth.getPayload());  
        let {user_id} = this.auth.getPayload()      
        this.handleNavigation({"username": username, "password": password, "server": this.serverString, "user_id": user_id});
      }
    }, ({ error, status }) => {

      this.loading = false;
      let translate = 'badLogin';
      let translateParams = '';
      let type = 'error';

      if (status === 403) {
        this.failedAttempts = 0;
        translate = 'lockedRetryTime';
        translateParams = error?.error?.[0].match(/\d+/)[0] || 20;
        // minutes extracted from error response
      }

      if (error?.error?.[0] === 'E-mail is not verified.') {
        translate = 'emailNotConfirmed';
        translateParams = username;
        type = 'info';
      }

      if(status === 400){
        this.bioService.deleteCredential(this.serverString)
      }

      this.authBioEnabled = false;
      this.showBioScreen = false;
      this.failedAttempts++;
      this.logger.showBanner({ translate, translateParams, type });
    });
  }

  invokeBiometrics(){
    if (this.bioAvail) {
      this.bioService.verifyIdentity().then((verified) => {
        if (verified) {
          this.bioService.pullCredentials(this.serverString).then((data) => {
            this.userForm.form.controls["username"].setValue(data.username);
            this.userForm.form.controls["password"].setValue(data.password);
            this.userForm.ngSubmit.emit();
          })
        } else {
          this.authBioEnabled = false;
          this.showBioScreen = false;
        }
      })
    }
  }
}

@NgModule({
  imports: [
    RouterModule,
    CommonModule,
    FormsModule,
    TranslocoModule,
    ShowPasswordModule,
    LazyNgxMaskModule,
    ButtonLoadingDirectiveModule
  ],
  declarations: [LoginFormComponent],
  exports: [LoginFormComponent]
})
export class LoginFormComponentModule {}
